import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './components/cozy/locales/english.json';
import cn from './components/cozy/locales/chinese.json';
import ja from './components/cozy/locales/japanese.json';
import kr from './components/cozy/locales/korean.json';
import fr from './components/cozy/locales/french.json';
import es from './components/cozy/locales/spanish.json';
import de from './components/cozy/locales/german.json';
// import bn from './components/cozy/locales/bangla.json';
// import sa from './components/cozy/locales/arabic.json';
// import my from './components/cozy/locales/malaysian.json';
// import sg from './components/cozy/locales/singaporean.json';
// import tw from './components/cozy/locales/taiwanese.json';

const savedLng = (() => {
    try { return localStorage.getItem('appLanguage') || 'en'; } catch (e) { return 'en'; }
})();

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },
            cn: {
                translation: cn,
            },
            ja: {
                translation: ja,
            },
            kr: {
                translation: kr,
            },
            fr: {
                translation: fr,
            },
            es: {
                translation: es,
            },
            de: {
                translation: de,
            },
            // bn: {
            //     translation: bn,
            // },
            // sa: {
            //     translation: sa,
            // },
            // my: {
            //     translation: my,
            // },
            // sg: {
            //     translation: sg,
            // },
            // tw: {
            //     translation: tw,
            // },
        },
        lng: savedLng,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;